/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router";
import LpLinksOverviewPage from "@/src/containers/Pages/Generic/LpLinksOverviewPage/LpLinksOverviewPage";
import LpModules from "@/src/containers/Pages/Divorce/LandingPagesDivorce/LpModules/LpModules";
import LpDivorce from "@/src/containers/Pages/Divorce/LandingPagesDivorce/LpDivorce/LpDivorce";
import LpFineDrivingBan from "@/src/containers/Pages/Traffic/LandingPagesTraffic/LpFineDrivingBan/LpFineDrivingBan";
import LpDismissal from "@/src/containers/Pages/Settlement/LandingsPagesSettlement/LpDismissal/LpDismissal";
import LpContractAdvocard from "@/src/containers/Pages/ContractLaw/LandingPagesContractLaw/AdvoCard/LpContractAdvocard";
import DismissalCheckAragPage from "@/src/containers/Pages/Settlement/LandingsPagesSettlement/LpDismissalArag/DismissalCheckAragPage";
import LpFineDrivingBanPartner from "@/src/containers/Pages/Traffic/LandingPagesTraffic/LpFineDrivingBanPartner/LpFineDrivingBanPartner";
import LpAlimonyPartner from "@/src/containers/Pages/FamilyLaw/LandingPagesFamilyLaw/LpAlimonyPartner";
import LpFamilyLawPartner from "@/src/containers/Pages/FamilyLaw/LandingPagesFamilyLaw/LpFamilyLawPartner";
import LpDivorcePartner from "@/src/containers/Pages/FamilyLaw/LandingPagesFamilyLaw/LpDivorcePartner";
import LpDeathPartner from "@/src/containers/Pages/FamilyLaw/LandingPagesFamilyLaw/LpDeathPartner";
import LpFamilyLawConsultingPartner from "@/src/containers/Pages/FamilyLaw/LandingPagesFamilyLaw/LpFamilyLawConsultingPartner";
import useTracker from "@/src/services/useTracker";
import HomePage from "@/src/containers/Pages/Generic/HomePage/HomePage";
import LpExternalLawyer from "@/src/containers/Pages/LpExternalLawyer/LpExternalLawyer";
import LpSpecialEnergyCasesAdvocard from "@/src/containers/Pages/ContractLaw/LandingPagesContractLaw/AdvoCard/LpSpecialEnergyCasesAdvocard";
import DismissalCheckWbsPage from "@/src/containers/Pages/Settlement/LandingsPagesSettlement/LpDismissalWbs/DismissalCheckWbsPage";
import LpTenancyLawAdvocard from "@/src/containers/Pages/TenancyLaw/LpTenancyLawAdvocard";
import LpAdvocardFlex from "@/src/containers/Pages/ContractLaw/LandingPagesContractLaw/AdvoCard/LpAdvocardFlex";
import LpCivilLawAdvocard from "@/src/containers/Pages/ContractLaw/LandingPagesContractLaw/AdvoCard/LpCivilLawAdvocard";
import LpEmploymentLawAdvocard from "@/src/containers/Pages/ContractLaw/LandingPagesContractLaw/AdvoCard/LpEmploymentLawAdvocard";
import LpTrafficAccident from "@/src/containers/Pages/TrafficLaw/LandingPagesTrafficLaw/LpTrafficAccident/LpTrafficAccident";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";
import LpContractAndCivilLawPartner from "@/src/containers/Pages/LpMixedProducts/LpContractAndCivilLawPartner.tsx";
import LpCivilServiceLawHuk from "@/src/containers/Pages/AdministrativeLaw/CivilServiceLaw/LpCivilServiceLawHuk";
import { logout } from "@/src/store/login/actions";
import { useQueryClient } from "@tanstack/react-query";

export default function LandingPage() {
  useTracker({ withGclid: true });
  const queryClient = useQueryClient();

  useEffect(() => {
    logout(queryClient);
  }, []);

  return (
    <Routes>
      <Route path={`links-overview`} element={<LpLinksOverviewPage />} />
      <Route path={`scheidung`} element={<LpDivorce />} />
      <Route path={`kuendigung`} element={<LpDismissal />} />
      <Route path={`bussgeld-fahrverbot`} element={<LpFineDrivingBan />} />
      <Route path={`verkehrsunfall`} element={<LpTrafficAccident />} />
      <Route path={`modules`} element={<LpModules />} />

      <Route path={`advocard/bussgeld-fahrverbot`} element={<LpFineDrivingBanPartner partnerIri={PARTNER_IRIS.ADVOCARD} />} />
      <Route path={`advocard/unterhalt`} element={<LpAlimonyPartner partner={PARTNER_IRIS.ADVOCARD} />} />
      <Route path={`advocard/familienrecht`} element={<LpFamilyLawPartner partner={PARTNER_IRIS.ADVOCARD} />} />
      <Route path={`advocard/scheidung`} element={<LpDivorcePartner partner={PARTNER_IRIS.ADVOCARD} />} />
      <Route path={`advocard/todesfall`} element={<LpDeathPartner partner={PARTNER_IRIS.ADVOCARD} />} />
      <Route path={`advocard/familienrecht-beratung`} element={<LpFamilyLawConsultingPartner partner={PARTNER_IRIS.ADVOCARD} />} />
      <Route path={`advocard/vertragsrecht`} element={<LpContractAdvocard />} />
      <Route path={`advocard/arbeitsrecht`} element={<LpEmploymentLawAdvocard />} />
      <Route path={`advocard/zivilrecht`} element={<LpCivilLawAdvocard />} />
      <Route path={`advocard/energie-hilfe`} element={<LpSpecialEnergyCasesAdvocard />} />
      <Route path={`advocard/mietrecht`} element={<LpTenancyLawAdvocard />} />
      <Route path={`advocard/flexservice`} element={<LpAdvocardFlex />} />

      <Route path={`arag/bussgeld-fahrverbot`} element={<LpFineDrivingBanPartner partnerIri={PARTNER_IRIS.ARAG} />} />
      <Route path={`arag/unterhalt`} element={<LpAlimonyPartner partner={PARTNER_IRIS.ARAG} />} />
      <Route path={`arag/familienrecht`} element={<LpFamilyLawPartner partner={PARTNER_IRIS.ARAG} />} />
      <Route path={`arag/scheidung`} element={<LpDivorcePartner partner={PARTNER_IRIS.ARAG} />} />
      <Route path={`arag/todesfall`} element={<LpDeathPartner partner={PARTNER_IRIS.ARAG} />} />
      <Route path={`arag/familienrecht-beratung`} element={<LpFamilyLawConsultingPartner partner={PARTNER_IRIS.ARAG} />} />
      <Route path={`arag/kuendigung`} element={<DismissalCheckAragPage />} />

      <Route path={`auxilia/familienrecht-beratung`} element={<LpFamilyLawConsultingPartner partner={PARTNER_IRIS.AUXILIA} />} />

      <Route path={`wbs/kuendigung`} element={<DismissalCheckWbsPage />} />
      <Route path={`wbs/schufa`} element={<Navigate to={"/lp/wbs/datenweitergabe"} replace={true} />} />

      <Route path={`deurag/familienrecht-beratung`} element={<LpFamilyLawConsultingPartner partner={PARTNER_IRIS.DEURAG} />} />

      <Route path={`huk/beamtenrecht`} element={<LpCivilServiceLawHuk />} />

      <Route path={`lvm/familienrecht-beratung`} element={<LpFamilyLawConsultingPartner partner={PARTNER_IRIS.LVM} />} />
      <Route path={`lvm/vertragsrecht-zivilrecht`} element={<LpContractAndCivilLawPartner partner={PARTNER_IRIS.LVM} />} />

      <Route path={`partneranwalt-werden`} element={<LpExternalLawyer />} />
      <Route path={"*"} element={<HomePage />} />
    </Routes>
  );
}
